import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { validateToken } from "@/utils/auth";

// Component Imports
import FacialBiometricsComponent from "./facial_biometrics_component/FacialBiometricsComponent.vue";
import OcrDocumentReader from "./ocr_document_reader/OcrDocumentReader.vue";

export default {
  name: "OcrLivenessVerification",
  mixins: [MAIN_CONTROLLER],
  components: {
    BreadCrumb,
    ClientLogo,
    FacialBiometricsComponent,
    OcrDocumentReader,
  },
  data() {
    return {
      liveness_photo: null,
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  methods: {
    set_liveness_photo(photo) {
      this.liveness_photo = photo;
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
  },
};